function isPhoneNumber (value) {
  return /^\+?\s*((([0-9]{1}\s*)+$|([0-9]{1}\s*)+-\s*([0-9]{1}\s*)+)|(([0-9]{1}\s*)+\(\s*([0-9]{1}\s*)+\)\s*(([0-9]{1}\s*)+$|([0-9]{1}\s*)+-\s*([0-9]{1}\s*)+)))$/.test(value);
}

module.exports = isPhoneNumber;
